/**
 * Sayz Widget — Merkezi Görsel Token Kaynağı
 *
 * Sayz Widget'ın kendisi ve tetiklediği popup'lar (Beden Tablosu, Bedenimi Bul)
 * dahil ZİYARETÇİYE görünen tüm yüzeylerde kullanılan tipografi + icon
 * boyutları buradan yönetilir. Merkezi tek kaynak — bir değeri buradan
 * güncellersen widget önizlemesi, popup'lar ve CTA'lar hep birlikte değişir.
 *
 * NOT: Merchant panel ayar UI'ı (ayar formları, tab'lar, License, Installation)
 * bu tokenları KULLANMAZ. Onlar genel panel design-system'inden beslenir.
 *
 * NOT: Live embed script (`widget-sizing-panel.js` & `core.js`) ayrı bir
 * kaynak — canlı ziyaretçilere çıkan HTML/CSS'te bu tokenlar sync değildir.
 * Kullanıcı canlı sync onayı verdiğinde script'e de aynı değerler taşınır.
 */

/**
 * Inline style için font boyutları (px). WidgetSizingPanel.jsx içindeki
 * `fs(N)` çağrısı fontScale uygulayan yardımcı; bu sabitleri parametre olarak
 * alır (`fs(WIDGET_TYPO.body)` → `fs(12.5)`).
 */
export const WIDGET_TYPO = {
    body:    12.5, // ana gövde metni — eskiden 11.5
    small:   11.5, // chip / etiket
    xsmall:  10.5, // micro-label / meta
    eyebrow:  9.5, // uppercase küçük başlık (ör. KALIP)
    label:    8.5, // en küçük — numaralama / spec
    ctaIcon: 13,   // CTA içindeki ikon boyutu (fs ile beraber kullanılır)
};

/**
 * Tailwind arbitrary-value className varyantları. JSX className içinde
 * template literal ile birleştirilir (`${WIDGET_TYPO_CLS.body} font-medium`).
 */
export const WIDGET_TYPO_CLS = {
    body:   "text-[12.5px]",
    small:  "text-[11.5px]",
    xsmall: "text-[10.5px]",
};

/**
 * İkon boyutları px cinsinden (Lucide `size={N}` için).
 */
export const WIDGET_ICON = {
    sm: 16, // eskiden 14 (h-3.5 w-3.5)
    md: 18, // eskiden 16 (h-4 w-4)
    lg: 20,
};

/**
 * Tailwind className varyantları (Lucide component'lerin `className` prop'una).
 */
export const WIDGET_ICON_CLS = {
    sm: "h-4 w-4",             // 16px
    md: "h-[18px] w-[18px]",   // 18px
    lg: "h-5 w-5",             // 20px
};
